import { useTranslation } from "react-i18next";
import SFCheckbox from "../../../checkbox";
import { SFStack } from "../../../grid";

const CheckboxRenderer = ({
  config,
  generatedFilter,
  onChange,
  loading,
  colDef,
}) => {
  const selectedValues = generatedFilter?.values ?? [];
  const { t } = useTranslation();
  const handleChange = (value, checked) => {
    if (config.loading) return;

    if (checked) {
      onChange([...selectedValues, value]);
    } else {
      onChange(selectedValues.filter((x) => x !== value));
    }
  };

  return (
    <SFStack direction="row" spacing={1}>
      {config.displayValues.map((x) => (
        <SFCheckbox
          key={x}
          label={x ?? t("components.datagrid.filters.blankValue")}
          checked={selectedValues.includes(x)}
          disabled={!config.values.includes(x)}
          onChange={(e) => handleChange(x, e.target.checked)}
          variant="body1"
        />
      ))}
    </SFStack>
  );
};

export default CheckboxRenderer;
